module.exports = __webpack_public_path__ + "media/images/group-eff6458c.png";